import i18n from "i18next";
import config from "shared/config";

export const getAuthProviderIfUnTenanted = (url: string): string | null => {
  if (url.includes("/admin")) {
    return config.adminAuthProvider;
  }
  return null;
};

export const getLoginUrl = (
  location: { pathname: string; search: string },
  instCode?: string,
): string => {
  const { pathname, search } = location;

  const authProvider = instCode || getAuthProviderIfUnTenanted(pathname);

  if (!authProvider) {
    const errorMessage = i18n.t(
      "authenticatedPage.error-unauthorised",
      "You are unauthorised for this page",
    );
    throw new Error(errorMessage);
  }

  const currentLocation = `${config.hostUrl}${pathname.slice(1)}${search}`;
  const loginUrl = new URL(
    `3/auth/providers/${authProvider}/login`,
    config.oauthOrigin,
  );
  loginUrl.searchParams.set("redirectUri", currentLocation);
  loginUrl.searchParams.set("app", config.oauthAppId);
  loginUrl.searchParams.set("nc", new Date().getTime().toString());
  return loginUrl.toString();
};
